import { DeviceType, GalleryPreview } from '../types/previewStudio';

export interface VideoInfo {
  videoUrl: string;
  width: number;
  height: number;
}

/**
 * Extract video URL and dimensions from a video creative's base64-encoded JSON adm.
 * Selects the best resolution based on device type (mobile prefers smaller, larger devices prefer HD).
 */
export function extractVideoInfo(preview: GalleryPreview, deviceType: DeviceType = 'mobile'): VideoInfo | null {
  if (!preview.is_video || !preview.adm) return null;

  try {
    const decoded = atob(preview.adm);
    const data = JSON.parse(decoded);
    if (!data.video_urls || typeof data.video_urls !== 'object') return null;

    const videoUrls = data.video_urls as Record<string, string>;

    const preferredSizes = deviceType === 'mobile'
      ? ['480x270', '320x180', '768x432', '1024x576']
      : ['1024x576', '768x432', '480x270', '320x180'];

    const matchedSize = preferredSizes.find((size) => videoUrls[size]);
    const [fallbackSize] = Object.keys(videoUrls);
    const resolvedSize = matchedSize || fallbackSize;
    if (!resolvedSize) return null;

    const [w, h] = resolvedSize.split('x').map(Number);
    return { videoUrl: videoUrls[matchedSize], width: w, height: h };
  } catch {
    return null;
  }
}
